import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export function usePageTracking() {
  const { pathname, search } = useLocation();
  const last = useRef(null);
  useEffect(() => {
    if (!GA_ID || typeof window.gtag !== "function") return undefined;
    const path = pathname + search;
    if (last.current === path) return undefined;
    last.current = path;
    const timer = setTimeout(() => {
      window.gtag("event", "page_view", {
        page_path: path,
        page_location: window.location.href,
        page_title: document.title,
        send_to: GA_ID,
      });
    }, 250);
    return () => clearTimeout(timer);
  }, [pathname, search]);
}
